import PrivacyPolicyCheckboxField from "components/inputs/CheckboxField/PrivacyPolicy";
import React from "react";

const Terms: React.FC = () => {
  return (
    <>
      <PrivacyPolicyCheckboxField
        required
        id="privacy-policy"
        name="privacyPolicy"
      />
    </>
  );
};

export default Terms;
